/* BlackBole welcome offer: mobile number + email -> Tk 50 coupon (WELCOME50) on normal products.
   Shows once, a few seconds after landing. The coupon then goes on by itself:
   - in the cash-on-delivery form (filled in and applied when the form opens)
   - at Shopify checkout (saved with /discount/CODE). Pre-order items never get it (the code only covers normal products). */
(function () {
  var C = window.BBWELCOME, root = document.getElementById('bbWelcome');
  if (!C || !root) return;
  var $ = function (id) { return document.getElementById(id); };
  var K = 'bbWelcome';
  function get() { try { return JSON.parse(localStorage.getItem(K) || 'null'); } catch (e) { return null; } }
  function put(v) { try { localStorage.setItem(K, JSON.stringify(v)); } catch (e) {} }
  function bdPhone(v) { var d = String(v || '').replace(/\D/g, ''); if (d.indexOf('880') === 0) d = d.slice(2); if (d.length === 10 && d[0] === '1') d = '0' + d; return /^01[3-9]\d{8}$/.test(d) ? d : ''; }
  function mailOk(v) { v = String(v || '').trim().toLowerCase(); return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(v) ? v : ''; }

  // ---------- popup ----------
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.classList.add('on'); root.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
    $('bbwTab').classList.remove('on');
    setTimeout(function () { root.querySelector('.bbw-card').focus({ preventScroll: true }); }, 60);
  }
  function close() {
    root.classList.remove('on'); root.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '';
    var s = get() || {};
    if (!s.code) { s.closedAt = Date.now(); put(s); $('bbwTab').classList.add('on'); } // a small tab stays so they can come back
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  [].forEach.call(root.querySelectorAll('[data-bbw-close]'), function (x) { x.addEventListener('click', close); });
  root.addEventListener('click', function (e) { if (e.target === root) close(); });
  addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });
  $('bbwTab').addEventListener('click', open);

  // known details from an earlier cash-on-delivery order or the gift box
  try { var me = JSON.parse(localStorage.getItem('bbCodMe') || '{}'); if (me.p) $('bbwPhone').value = me.p; if (me.e) $('bbwEmail').value = me.e; } catch (e) {}
  try { if (!$('bbwPhone').value) $('bbwPhone').value = localStorage.getItem('bbGiftPhone') || ''; if (!$('bbwEmail').value) $('bbwEmail').value = localStorage.getItem('bbGiftEmail') || ''; } catch (e) {}
  ['bbwPhone', 'bbwEmail'].forEach(function (id) { $(id).addEventListener('input', function () { $('bbwErr').textContent = ''; }); });

  $('bbwForm').addEventListener('submit', function (e) {
    e.preventDefault();
    var p = bdPhone($('bbwPhone').value), m = mailOk($('bbwEmail').value);
    if (!p) { $('bbwErr').textContent = 'Please give a valid mobile number, like 01712345678.'; $('bbwPhone').focus(); return; }
    if (!m) { $('bbwErr').textContent = 'Please give a valid email address, like name@gmail.com.'; $('bbwEmail').focus(); return; }
    var go = $('bbwGo'); go.disabled = true; go.textContent = 'One moment…';
    fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'welcome', phone: p, email: m, page: location.pathname.slice(0, 200) }) })
      .then(function (r) { return r.json(); })
      .catch(function () { return { ok: true, code: C.code }; }) // offline save failed: still give the coupon
      .then(function (j) {
        go.disabled = false; go.textContent = 'Get my Tk 50 off';
        if (!j || !j.ok) { $('bbwErr').textContent = (j && j.message) || 'Something went wrong. Please try again.'; return; }
        var code = j.code || C.code;
        put({ code: code, phone: p, email: m, at: Date.now() });
        // fill the cash-on-delivery form next time (name and address still empty)
        try { var s = JSON.parse(localStorage.getItem('bbCodMe') || '{}'); if (!s.p) s.p = p; if (!s.e) s.e = m; localStorage.setItem('bbCodMe', JSON.stringify(s)); } catch (er) {}
        applyCheckout(code);
        $('bbwCode').textContent = code; root.classList.add('got');
      });
  });
  $('bbwCopy').addEventListener('click', function () {
    var b = this; (navigator.clipboard ? navigator.clipboard.writeText($('bbwCode').textContent) : Promise.reject()).then(function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1500); }).catch(function () {});
  });

  // ---------- put the coupon on the order ----------
  // Shopify checkout: remember the code for this visitor
  function applyCheckout(code) { try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }
  // cash-on-delivery form: when it opens, type the code into its coupon box and press Apply
  var cod = document.getElementById('bbCod');
  if (cod && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var s = get(); if (!s || !s.code || !cod.classList.contains('on')) return;
      setTimeout(function () {
        var box = document.getElementById('codCode'), btn = document.getElementById('codApply');
        if (!box || !btn || box.value) return;
        box.value = s.code; btn.click();
      }, 250);
    }).observe(cod, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------- when to show ----------
  var s0 = get();
  if (s0 && s0.code) { applyCheckout(s0.code); return; }                // already has it: nothing to show
  if (s0 && s0.closedAt) { $('bbwTab').classList.add('on'); return; }  // said "no thanks" before: only the small tab
  setTimeout(function () {
    // never on top of another popup (gift box, cash-on-delivery form, size chart)
    if (document.querySelector('.bbg.on, #bbCod.on') || document.documentElement.style.overflow === 'hidden') { $('bbwTab').classList.add('on'); return; }
    open();
  }, 6000);
})();
